module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('form', {
    staticClass: "personal-form",
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveUserInfo($event)
      }
    }
  }, [_c('scroll', {
    attrs: {
      "id": "personal-scroll"
    },
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "mylogin"
  }, [_c('div', {
    staticClass: "camera"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }), _vm._v(" "), _c('div', {
    staticClass: "myphoto"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "list list-personal"
  }, [_c('li', {
    staticClass: "list-item person-show-click"
  }, [_c('div', {
    staticClass: "f-minor item-left"
  }, [_vm._v("姓名")]), _vm._v(" "), (!_vm.isTFY) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saveInfo.name),
      expression: "saveInfo.name"
    }],
    staticClass: "ipt-inline person-input",
    class: _vm.showInput == false ? 'person-hiden' : 'person-show',
    staticStyle: {
      "background": "#fff"
    },
    attrs: {
      "type": "text",
      "id": "person-input-name",
      "placeholder": "请输入用户姓名",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.saveInfo.name)
    },
    on: {
      "focus": function($event) {
        _vm.showInput = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.saveInfo, "name", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.saveInfo.name),
      expression: "saveInfo.name"
    }],
    staticClass: "ipt-inline person-input",
    class: _vm.showInput == false ? 'person-hiden' : 'person-show',
    staticStyle: {
      "background": "#fff"
    },
    attrs: {
      "type": "text",
      "id": "person-input-name",
      "placeholder": "请输入用户姓名",
      "maxlength": "20",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.saveInfo.name)
    },
    on: {
      "focus": function($event) {
        _vm.showInput = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.saveInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "list-item"
  }, [_c('div', {
    staticClass: "f-minor item-left"
  }, [_vm._v("身份证号")]), _vm._v(" "), (!_vm.isTFY) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certNo),
      expression: "certNo"
    }],
    staticClass: "ipt-inline person-input",
    class: _vm.showInput == false ? 'person-hiden' : 'person-show',
    staticStyle: {
      "background": "#fff"
    },
    attrs: {
      "type": "text",
      "id": "person-input-card",
      "placeholder": "请输入身份证号码",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.certNo)
    },
    on: {
      "focus": function($event) {
        _vm.showInput = true;
        _vm.certNo = _vm.saveInfo.certNo;
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.certNo = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.certNo),
      expression: "certNo"
    }],
    staticClass: "ipt-inline person-input",
    class: _vm.showInput == false ? 'person-hiden' : 'person-show',
    staticStyle: {
      "background": "#fff"
    },
    attrs: {
      "type": "text",
      "id": "person-input-card",
      "placeholder": "请输入身份证号码",
      "maxlength": "20",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.certNo)
    },
    on: {
      "focus": function($event) {
        _vm.showInput = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.certNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "arr-item list-item person-click-phone",
    on: {
      "click": _vm.goModifyPhone
    }
  }, [_c('div', {
    staticClass: "f-minor item-left"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('span', {
    staticClass: "f-minor",
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("dotted")(_vm.userInfo.mobileNo)))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showInput),
      expression: "!showInput"
    }],
    staticClass: "logo-out"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isTFY),
      expression: "!isTFY"
    }],
    staticClass: "logout",
    attrs: {
      "id": "logout",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("\n          退出登录\n        ")])])]), _vm._v(" "), _c('footer', {
    staticClass: "save-btn"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInput),
      expression: "showInput"
    }],
    staticClass: "btn-complete",
    attrs: {
      "id": "person-input-save",
      "type": "submit"
    }
  }, [_vm._v("\n        保 存\n      ")])])], 1), _vm._v(" "), _c('confirm', {
    attrs: {
      "text": "确认退出登录？"
    },
    on: {
      "on-sure": _vm.doLogoutRequest
    },
    model: {
      value: (_vm.showConfirm),
      callback: function($$v) {
        _vm.showConfirm = $$v
      },
      expression: "showConfirm"
    }
  }), _vm._v(" "), _c('confirm', {
    attrs: {
      "title": "保存提示",
      "text": "信息未保存，请先点确定保存"
    },
    on: {
      "on-cancel": _vm.cancelsave,
      "on-sure": _vm.saveUserInfo
    },
    model: {
      value: (_vm.showMessage),
      callback: function($$v) {
        _vm.showMessage = $$v
      },
      expression: "showMessage"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62376e1c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/profile/Personal.vue
// module id = 841
// module chunks = 0